import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';
import { addressSchema, addressUI } from '../../../definitions';
import content from '../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../utils/imports';

const TITLE_TEXT = content['secondary-two-info-title--address-mailing'];
const DESC_TEXT = content['caregiver-address-description--mailing'];

const ADDRESS_PROPS = FULL_SCHEMA.definitions.mailingAddress.properties;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, DESC_TEXT),
    secondaryTwoMailingAddress: addressUI({ requireCounty: false }),
  },
  schema: {
    type: 'object',
    required: ['secondaryTwoMailingAddress'],
    properties: {
      secondaryTwoMailingAddress: addressSchema({ extend: ADDRESS_PROPS }),
    },
  },
};
